import { Icon } from '@iconify/react';

import { ContentType } from '../../../types/contentTypes';
import { ICON_SIZES, IconSize } from '../button/IconButton';

const CONTENT_TYPE_TO_ICON = new Map<ContentType, string>([
  [ContentType.Video, 'play-circle-outline'],
  [ContentType.Text, 'text-snippet-outline'],
  [ContentType.CodeLab, 'code'],
  [ContentType.InteractiveImage, 'photo-camera-outline'],
  [ContentType.Quiz, 'quiz-outline'],
  [ContentType.Pdf, 'file-open-outline-rounded'],
]);
interface ContentTypeIconProps {
  type: ContentType;
  iconSize?: IconSize;
  className?: string;
}

export default function ContentTypeIcon({ type, iconSize = 'sm', className = '' }: ContentTypeIconProps) {
  return (
    <Icon
      className={className}
      icon={`material-symbols:${CONTENT_TYPE_TO_ICON.get(type)}`}
      height={ICON_SIZES[iconSize]}
      width={ICON_SIZES[iconSize]}
    />
  );
}
